import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

/**
 * Reusable breadcrumb. Pass `items` as an array of {label, to?} objects.
 * The last item is rendered as plain text (current page).
 */
export default function Breadcrumbs({ items = [] }) {
  if (!items.length) return null;
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="text-xs sm:text-[13px]">
      <ol className="flex flex-wrap items-center gap-1.5" style={{ color: "var(--ct-text-muted)" }}>
        <li className="flex items-center gap-1.5">
          <Link to="/" className="inline-flex items-center gap-1 hover:text-[var(--ct-link)] transition-colors" data-testid="breadcrumb-home">
            <Home size={13} /> Acasă
          </Link>
        </li>
        {items.map((it, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={i} className="flex items-center gap-1.5">
              <ChevronRight size={13} style={{ color: "var(--ct-gold)" }} />
              {isLast || !it.to ? (
                <span aria-current="page" className="font-medium" style={{ color: "var(--ct-link)" }} data-testid={`breadcrumb-current`}>
                  {it.label}
                </span>
              ) : (
                <Link to={it.to} className="hover:text-[var(--ct-link)] transition-colors" data-testid={`breadcrumb-${i}`}>
                  {it.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
